const casePaidTaskReviewStyles = {
  BLOCKER: { bgcolor: "error.dark", color: "error.contrastText" },
  HIGH: { bgcolor: "warning.main", color: "warning.contrastText" },
  MEDIUM: { bgcolor: "background.note", color: "text.primary" },
  INFO: { bgcolor: "grey.200", color: "text.primary" },
};

export default casePaidTaskReviewStyles;
